import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { AppDispatch } from "../../../core/data/redux/store";
import { useDispatch } from "react-redux";

import {
  exportToCSV,
  exportToExcel,
} from "../../../core/common/GlobalFunctions/exportTableData";
import { fetchAll_Employee_shift_Details, fetchAll_Shift_Count, fetchAll_Shift_Report } from "../../../core/data/redux/reports/shift_report/shift.Action";
import { Form, Row, Col, Card, Badge, Button } from "react-bootstrap";


interface Props {
  records: any;
  selectedMonth: number; // 1-12
  selectedYear: number;
}

interface ShiftReportProps {
  showOnlyTable?: boolean;
}


const Shift_Report: React.FC<ShiftReportProps> = ({showOnlyTable}) => {
  const dispatch = useDispatch<AppDispatch>();
  // const { records } = useSelector((state: any) => state.accounting.expenses);
  const [selectedYear, setSelectedYear] = useState("2025");
  const [chartdata, setchartdata] = useState<any[]>([]);
  const [count, setcount] = useState<any>("");
  const [mockRecords, setmockRecords] = useState<any>([])

  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAll_Shift_Report(selectedYear)).then((res) => {
        setchartdata(res.payload.data);
      });
    }
  }, [selectedYear, dispatch]);

  useEffect(() => {
      dispatch(fetchAll_Employee_shift_Details({ year: 2025, month: 11 }))
      .then((res) => {
        setmockRecords(res.payload.data)
      });
    
    dispatch(fetchAll_Shift_Count())
    .then((res) => {
      setcount(res.payload.data)
    })
  }, [dispatch])

  const data = mockRecords ? mockRecords : [];

  function filterExpenseData(data: any[]) {
    return data.map(expense => ({
      expenseName: expense.expense_name || "N/A",
      paymentMethod: expense.payment_method || "N/A",
      requestStatus: expense.requestStatus || "N/A",
      paymentStatus: expense.paymentStatus || "N/A",
      expenseDate: new Date(expense.expense_date).toLocaleDateString(),
      amount: expense.amount || "0.00"
    }));
  }

  const data2 = filterExpenseData(data)


  const handleYearSelect = (year: any) => { setSelectedYear(year); };

  const [expensechart, setexpensechart] = useState<any>({
    series: [],
    chart: {
      height: 190,
      type: "bar",
      stacked: false,
      zoom: { enabled: false },
    },
    colors: ["#FF9F43", "#7367F0", "#00CFE8", "#28C76F", "#EA5455"],
    dataLabels: { enabled: false },
    xaxis: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      ],
    },
    yaxis: {
      min: 0,
      labels: { formatter: (val: number) => val.toString() },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  });


  useEffect(() => {
    if (chartdata && chartdata.length > 0) {
      const shiftNames = [...new Set(chartdata.map((d: any) => d.ShiftName))];

      const seriesData = shiftNames.map((shift) => {
        const monthlyData = new Array(12).fill(0);

        chartdata.forEach(({ ShiftName, MonthNumber, EmployeeCount }: any) => {
          if (ShiftName === shift) {
            monthlyData[MonthNumber - 1] = EmployeeCount;
          }
        });

        return { name: shift, data: monthlyData };
      });

      setexpensechart((prev: any) => ({
        ...prev,
        series: seriesData,
      }));
    } else {
      // reset chart if no data
      setexpensechart((prev: any) => ({
        ...prev,
        series: [],
      }));
    }
  }, [chartdata]);


  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAll_Shift_Report(selectedYear)).then((res) => {
        setchartdata(res.payload.data);  // update chart data
      });
    }
  }, [selectedYear, dispatch]);

  const ShiftCalendar: React.FC<Props> = ({ records, selectedMonth, selectedYear }) => {
    const dispatch = useDispatch<any>();
    const [employees, setEmployees] = useState<any>([]);
    const [daysInMonth, setDaysInMonth] = useState<number[]>([]);
    const [selectedEmployee, setSelectedEmployee] = useState<string>("");
    const [selectedShift, setSelectedShift] = useState<string>("");

    const [mockRecords, setMockRecords] = useState<any>([]);

   
    const [searchMonth, setSearchMonth] = useState<number>(selectedMonth);
    const [searchYear, setSearchYear] = useState<number>(selectedYear);

   
    useEffect(() => {
      const uniqueEmployees = [...new Set(records.map((r: any) => r.EmployeeName))];
      setEmployees(uniqueEmployees);

      const days = new Date(selectedYear, selectedMonth, 0).getDate();
      setDaysInMonth(Array.from({ length: days }, (_, i) => i + 1));
    }, [records, selectedMonth, selectedYear]);

  
    const handleSearch = () => {
      dispatch(fetchAll_Employee_shift_Details({ year: searchYear, month: searchMonth }))
        .then((res: any) => {
          setMockRecords(res.payload.data);
        });
    };

    // Filtering
    const filteredRecords = mockRecords.filter((r: any) => {
      return (
        (selectedEmployee ? r.EmployeeName === selectedEmployee : true) &&
        (selectedShift ? r.ShiftName === selectedShift : true)
      );
    });

    // Group by employee
    const employeeMap: { [key: string]: { [day: number]: string } } = {};
    filteredRecords.forEach((r: any) => {
      const day = new Date(r.Date).getDate();
      if (!employeeMap[r.EmployeeName]) employeeMap[r.EmployeeName] = {};
      employeeMap[r.EmployeeName][day] = r.ShiftName;
    });

    // Unique shifts
    const shifts = [...new Set(records.map((r: any) => r.ShiftName))];

    return (
      <>
        {/* Search filter row (Month, Year, Search button) */}
        <Card className="mb-3 shadow-sm border-0 rounded-4">
          <Card.Body>
            <Row className="align-items-center g-3">
              <Col md={3}>
                <Form.Select value={searchMonth} onChange={(e) => setSearchMonth(Number(e.target.value))}>
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {new Date(0, i).toLocaleString("default", { month: "long" })}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col md={3}>
                <Form.Control
                  type="number"
                  value={searchYear}
                  onChange={(e) => setSearchYear(Number(e.target.value))}
                />
              </Col>
              <Col md={2}>
                <Button variant="primary" className="w-100" onClick={handleSearch}>
                  Search
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Main shift calendar */}
        <Card className="shadow-sm border-0 rounded-4">
          <Card.Header className="bg-primary text-white rounded-top-4">
            <Row className="align-items-center g-3">
              <Col md={4}>
                <Form.Select value={selectedEmployee} onChange={(e) => setSelectedEmployee(e.target.value)}>
                  <option value="">All Employees</option>
                  {employees.map((emp: any, i: any) => (
                    <option key={i} value={emp}>
                      {emp}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col md={4}>
                <Form.Select value={selectedShift} onChange={(e) => setSelectedShift(e.target.value)}>
                  <option value="">All Shifts</option>
                  {shifts.map((shift: any, i: any) => (
                    <option key={i} value={shift}>
                      {shift}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
          </Card.Header>

          <Card.Body style={{ overflowX: "auto" }}>
            {/* Days header row */}
            <div
              className="d-grid border-bottom pb-2 mb-2"
              style={{
                gridTemplateColumns: `200px repeat(${daysInMonth.length}, 50px)`,
                display: "grid",
                gap: "4px",
                fontWeight: "bold",
              }}
            >
              <div className="text-dark">Employee</div>
              {daysInMonth.map((day) => (
                <div key={day} className="text-center text-muted" style={{ fontSize: "0.85rem" }}>
                  {day}
                </div>
              ))}
            </div>

            {/* Employee rows */}
            {Object.entries(employeeMap).map(([employee, shifts], idx) => (
              <div
                key={employee}
                className="d-grid py-2 border-bottom"
                style={{
                  gridTemplateColumns: `200px repeat(${daysInMonth.length}, 50px)`,
                  display: "grid",
                  gap: "4px",
                  backgroundColor: idx % 2 === 0 ? "#f9fafb" : "transparent",
                }}
              >
                <div className="fw-semibold">{employee}</div>
                {daysInMonth.map((day) => (
                  <div key={day} className="text-center">
                    {shifts[day] ? (
                      <Badge bg="info" className="rounded-pill px-2">
                        {shifts[day]}
                      </Badge>
                    ) : (
                      "-"
                    )}
                  </div>
                ))}
              </div>
            ))}
          </Card.Body>
        </Card>
      </>
    );
  };


if (showOnlyTable) {
  return (
<>
          <div className="row mt-4">
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            </div>
            <div className="card-body p-0">
              <div className="container my-4">
                <ShiftCalendar records={mockRecords} selectedMonth={9} selectedYear={2025} />
              </div>
            </div>
          </div>
</>
  );
}

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Shift and Schedule Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HRM</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Shift and Schedule Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data, "Shift_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data, "Shift_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            {/* Total Exponses */}
            <div className="col-xl-6 d-flex">
              <div className="row flex-fill">
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/total-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Total Employee
                          </span>
                          <h5>{count ? count?.[0].TotalEmployees : 0}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-primary border border-primary"
                        >
                          <span className="text-primary">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +20.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/approved-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Total Department
                          </span>
                          <h5>{count ? count?.[0].TotalDepartments : 0}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-success border border-success"
                        >
                          <span className="text-success">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +17.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/pending-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Total Shift
                          </span>
                          <h5>{count ? count?.[0].TotalShifts : 0}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-skyblue border border-skyblue"
                        >
                          <span className="text-skyblue">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +10.13%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/reject-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            
                          </span>
                          <h5>{count ? count?.[0].pending_count : 0}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-danger border border-danger"
                        >
                          <span className="text-danger">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-danger fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    -10.17%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Exponses */}
            {/* Total Exponses */}
            <div className="col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-area-line text-danger" />
                      </span>
                      <h5>Shift</h5>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-2">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2026")}
                          >
                            2026
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2025")}
                          >
                            2025
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2024")}
                          >
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2023")}
                          >
                            2023
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-0">
                  <ReactApexChart
                    id="shift-analysis"
                    options={expensechart}
                    series={expensechart.series}
                    type="bar"
                    height={193}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            </div>
            <div className="card-body p-0">
              <div className="container my-4">
                <ShiftCalendar records={mockRecords} selectedMonth={9} selectedYear={2025} />
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default Shift_Report;
